import React from 'react';
import { observer } from 'mobx-react';
import { Loader, BaasicInput, BaasicDropdown } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import _ from 'lodash';
import { FulfillmentOrderItemsTooltip } from 'common/tooltips';

const BulkPrintTemplate = ({
	t,
	bulkPrintViewStore,
	bulkPrintViewStore: { loading, bulkPrintForm, modalParams },
}) => {
	if (loading) return <Loader />;
	return (
		<section>
			<form className="ReactModal__form" onSubmit={bulkPrintForm.onSubmit}>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{t('FULFILLMENTORDER.BULKPRINT.BOXDIMENSIONS')}</h3>
				</div>
				<div className="ReactModal__body">
					<div className="box--primary box--sml spc--bottom--xsml">
						<table className="table--secondary">
							<colgroup>
								<col width="110" />
								<col />
							</colgroup>
							<thead>
								<tr>
									<th>{t('FULFILLMENTORDER.BULKPRINT.FO')}</th>
									<th>
										{t('FULFILLMENTORDER.BULKPRINT.DIMENSIONS')}
										<span className="type--color--warning">*</span>
									</th>
								</tr>
							</thead>
							<tbody>
								{bulkPrintForm.$('fulfillmentOrders').map((fulfillmentOrder, index) => {
									if (fulfillmentOrder.$('isBoxRequired').value) {
										fulfillmentOrder.$('boxId').set('rules', 'required');
									}
									return (
										<tr key={index}>
											<td>
												<div className="flex--primary">
													<span className="display--b">{fulfillmentOrder.$('fulfillmentOrderId').value}</span>
													<div>
														<FulfillmentOrderItemsTooltip
															fulfillmentOrderId={fulfillmentOrder.value.id}
															fulfillmentOrderItems={fulfillmentOrder.value.fulfillmentOrderItems}
														/>
													</div>
												</div>
											</td>
											<td>
												<BaasicDropdown
													dropdownStore={fulfillmentOrder.boxDropdownStore}
													placeholder={
														fulfillmentOrder.$('isBoxRequired').value
															? undefined
															: t('FULFILLMENTORDER.BULKPRINT.BOXNOTREQUIRED')
													}
													isDisabled={!fulfillmentOrder.$('isBoxRequired').value}
													className="flex--grow--1"
													showLabel={false}
												/>
											</td>
										</tr>
									);
								})}
							</tbody>
						</table>
					</div>

					<BoxCreate bulkPrintViewStore={bulkPrintViewStore} t={t} />

					{bulkPrintForm.error != null && <p className="type--color--warning">{translate(bulkPrintForm.error)}</p>}
				</div>
				<div className="ReactModal__footer">
					<button
						className="btn btn--med btn--primary spc--right--tny spc--bottom--sml"
						type="submit"
						disabled={loading}
					>
						{loading ? (
							<div className="spinnercont spc--right--sml">
								<div className="spinner"></div>
							</div>
						) : null}
						{t('SAVE')}
					</button>
					<button
						className="btn btn--med btn--outline spc--bottom--sml"
						type="button"
						onClick={modalParams.close}
					>
						{t('FULFILLMENTORDER.LABELINGMODE.DIMENSIONSSTEP.CANCEL')}
					</button>
				</div>
			</form>
		</section>
	);
};

export default defaultTemplate(BulkPrintTemplate);

const BoxCreate = observer(
	({
		bulkPrintViewStore: {
			boxForm,
			onCreateBoxTemplate,
			createBoxTemplateSuccessMessage,
			createBoxTemplateErrorMessage,
		},
		t,
	}) => {
		return (
			<div className="box--primary box--sml spc--bottom--sml" onSubmit={boxForm.onSubmit}>
				<div className="box__header">
					<h4 className="box__header__title">{t('FULFILLMENTORDER.BULKPRINT.CREATEBOX.TITLE')}</h4>
				</div>
				<div className="row row--form">
					<div className="col col-sml-12 spc--bottom--sml">
						<BaasicInput field={boxForm.$('name')} placeholder={t('FULFILLMENTORDER.BULKPRINT.CREATEBOX.NAME')} />
					</div>
					<div className="col col-sml-12 col-med-6 col-lrg-4">
						<BaasicInput field={boxForm.$('height')} placeholder={t('FULFILLMENTORDER.BULKPRINT.CREATEBOX.HEIGHT')} />
					</div>
					<div className="col col-sml-12 col-med-6 col-lrg-4">
						<BaasicInput field={boxForm.$('width')} placeholder={t('FULFILLMENTORDER.BULKPRINT.CREATEBOX.WIDTH')} />
					</div>
					<div className="col col-sml-12 col-med-6 col-lrg-4">
						<BaasicInput field={boxForm.$('length')} placeholder={t('FULFILLMENTORDER.BULKPRINT.CREATEBOX.LENGTH')} />
					</div>
				</div>

				<div>
					<button
						className="btn btn--sml btn--primary spc--right--sml"
						type="button"
						onClick={() => onCreateBoxTemplate()}
					>
						{t('FULFILLMENTORDER.BULKPRINT.CREATEBOX.CREATE')}
					</button>
					<button className="btn btn--sml btn--outline" type="button" onClick={() => boxForm.reset()}>
						{t('FULFILLMENTORDER.BULKPRINT.CREATEBOX.CANCEL')}
					</button>
				</div>
				{createBoxTemplateSuccessMessage && (
					<div className="type--color--success spc--top--sml">{t(createBoxTemplateSuccessMessage)}</div>
				)}
				{createBoxTemplateErrorMessage && (
					<div className="type--color--warning spc--top--sml">{t(createBoxTemplateErrorMessage)}</div>
				)}
			</div>
		);
	}
);
